import { RESERVED_SUBDOMAINS } from "@shared/constants";
import { isE2E } from "@shared/utils";
import { isRootDomain } from "@apps/patient-core/src/app/utils";

/**
 * The placeholder values are replaced by:
 * '_getReplaceValues' when deploying through SST
 * 'scripts/dev/devenv.ts' when running locally
 */
export const environment = {
  ACCOUNT: "770966829753",
  get ANALYTICS_MIXPANEL_ROUTE_TRACKING() {
    return ["true"].includes("true"); // To prevent "This comparison appears to be unintentional because the types '"true"' and '"true"' have no overlap" error
  },
  get APP_PATIENT_URL() {
    return `https://${this.STAGE}-patient.${this.HOST_ZONE}/`;
  },
  BACKEND_DOMAIN: "portal.dental",
  CONCIERGE_APP_NAME: "Dentally Portal",
  get CUSTOM_DOMAINS() {
    const customDomains = "[{"domainNames":["dental.bupa.co.uk","*.smiles.dentr.net","*.bupa-wales.dentr.net","*.bupa-ni.dentr.net","bupa-scotland.dentr.net","dental-wales.bupa.co.uk","*.bupa.dentr.net","smiles.dentr.net","dental-ni.bupa.co.uk","dental.smiles.ie","bupa-ni.dentr.net","bupa-roi.dentr.net","*.bupa-scotland.dentr.net","*.bupa-roi.dentr.net","bupa.dentr.net","bupa-wales.dentr.net","dental-scotland.bupa.co.uk"],"stage":"p-euw1-bupa1"}]";

    if (customDomains.startsWith("[")) return JSON.parse(customDomains);

    return [];
  },
  ENABLE_SERVICE_WORKER: "false",
  get ENABLE_NEW_PATIENT_AUTOFILL() {
    return ["true"].includes("false"); // To prevent "This comparison appears to be unintentional because the types '"false"' and '"true"' have no overlap" error
  },
  GA_TRACKING_ID_PATIENT_APP: "UA-124047875-2",
  get GLOBAL_URL() {
    if (isE2E(this.STAGE)) {
      return `https://global-${this.STAGE}-api.${this.BACKEND_DOMAIN}`;
    }

    return `https://api.${this.BACKEND_DOMAIN}`;
  },
  get GRAPH_URL() {
    return `https://${this.STAGE}-graph.${this.BACKEND_DOMAIN}/`;
  },
  HOST_ZONE: "portal.dental",
  get IS_GLOBAL_DOMAIN() {
    return new RegExp(`(${RESERVED_SUBDOMAINS.join("|")})\.${this.HOST_ZONE}`).test(location.hostname);
  },
  get IS_PROD() {
    return ["true"].includes("true"); // To prevent "This comparison appears to be unintentional because the types '"true"' and '"true"' have no overlap" error
  },
  PATIENT_APP_PUSHER_CLUSTER: "eu",
  PATIENT_APP_PUSHER_EVENT: "online_booking_update",
  PATIENT_APP_PUSHER_KEY: "1c91060ed9168cfefd22",
  PWA_INSTALLABLE: "true",
  get REGION() {
    return window.REGION || "eu-west-1";
  },
  get REST_LEGACY_URL() {
    return `https://${this.STAGE}-apis.${this.BACKEND_DOMAIN}`;
  },
  get REST_URL() {
    return `https://${this.STAGE}-rest.${this.BACKEND_DOMAIN}`;
  },
  get STAGE() {
    return window.STAGE || "production";
  },
  get IS_STAGE_UNKNOWN() {
    return isRootDomain() && this.STAGE === "production";
  },
  VERSION: "v6.34.0",
  clearCache: true,
  hmr: false,
  production: true,
  releaseStage: "dev",
};
